import { RootState } from '@/redux/reducers'
import { sagaActions } from '@/redux/sagaActions'
import { createSelector } from '@reduxjs/toolkit'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { useGameData } from './useGameData'

// Selector for the rounds
const selectRounds = (state: RootState) => state.games?.rounds?.rounds ?? []

// Selector for loading states (only rounds, game loading handled by useGameData)
const selectRoundsLoading = (state: RootState) => state.games.loading.rounds

// Selector for error
const selectError = (state: RootState) => state.games.error

// Combined selector using createSelector for memoization
const gamePageSelector = createSelector(
  selectRounds,
  selectRoundsLoading,
  selectError,
  (rounds, loading, error) => ({
    rounds,
    loading,
    error,
  }),
)

export const useRoundPage = () => {
  const { gameId } = useParams()
  const dispatch = useDispatch()

  // Use the shared hook for game data
  const {
    game,
    gameTitle,
    loading: gameLoading,
    error: gameError,
  } = useGameData({ gameId })

  // Still need to fetch rounds separately as it's specific to this hook
  const {
    rounds,
    loading: roundsLoading,
    error: roundsError,
  } = useSelector(gamePageSelector)

  useEffect(() => {
    if (gameId) {
      dispatch({
        type: sagaActions.FETCH_LIST_GAME_ROUND,
        payload: { gameId },
      })
    }
  }, [dispatch, gameId])

  return {
    rounds,
    game,
    loading: gameLoading || roundsLoading,
    error: gameError || roundsError,
    gameTitle,
  }
}
